import { Box, Image, SimpleGrid } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import joyBanner from "../../Assets/joy_banner.gif"
import lotusBanner from "../../Assets/lotus_banner.gif"

export default function Banner2() {
  return (
    <>
      <SimpleGrid
        className="ThirtyPercentBannerSimpleGrid"
        m="auto"
        gap="3%"
        columns={[1, 1, 2]}
        w={{ base: "95%", md: "95%", lg: "90%" }}
      >
        <Box w={{ base: "95%", md: "90%", lg: "100%" }}>
          <Link to={"/mombabycare"}>
            <Image
              w="100%"
              src={joyBanner}
            />
          </Link>
        </Box>

        <Box w={{ base: "95%", md: "90%", lg: "100%" }}>
          <Link to="/hair">
            <Image
              w="100%"
              src={lotusBanner}
            />
          </Link>
        </Box>
      </SimpleGrid>
    </>
  );
}
